import React, { memo } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const TextArea = (props)=>{
  const  {
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  const attr = formFieldsAttributes(
      {...item,className:className},
      validationForms);
  return(
    <FormBlocks {...props} attr={attr}>
      <textarea 
        value={attr.value}
        onChange={(e) =>props.onChangeInputAction(fieldObj,e)}
        onBlur={(e)=>props.onBlurHandlerAction(fieldObj,e)}
        {...attr.fieldAttributes} />
      </FormBlocks>
  )
};

TextArea.defaultProps = {
  generator: false,
  className: "form-control"
}

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(TextArea,isDiffProps);

// import React, { Component } from "react";
// import {FormBlocks} from './FormBlocks';
// import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

// class TextArea extends Component {
//   render() {
//     const  {
//       item,
//       className,
//       section,
//       validationForms,
//       subformObj
//     } = this.props;

//     const updateData = {
//       section_index:section.section_index,
//       itemIndex:item.itemIndex,
//       item:item,
//       ...subformObj
//     }
//     const attr = formFieldsAttributes(
//       {...item,className:className
//     },validationForms,e => this.props.onChangeInputAction(updateData,e));


//     return (
//       <FormBlocks {...this.props}  attr={attr}>
//           <textarea 
//             value={attr.value}
//             {...attr.fieldAttributes}
//             onChange={attr.onChange}
//           />
//       </FormBlocks>
//     );
//   }
// }

// TextArea.defaultProps = {
//   generator: false,
//   className: "form-control"
// }

// export default TextArea;
